export default __webpack_public_path__ + "static/media/0_Still.f328de30.jpg";